import { useCallback } from 'react';
import type { UserResponse } from 'stream-chat';
import { useMessageComposer } from 'stream-chat-react';

export function useHandleMentionUser(onMentionUser?: (user: UserResponse) => void) {
  const { textComposer } = useMessageComposer();

  return useCallback(
    (user: UserResponse) => {
      onMentionUser?.(user);
      textComposer.upsertMentionedUser(user);
      textComposer.insertText({
        text: `@${user.name} `,
        selection: { start: 0, end: 0 },
      });
    },
    [onMentionUser, textComposer],
  );
}
